export default {
  computed: {
    canShipAllDropships() {
      for (let selected of this.selectedForProcessing) {
        if (selected.dropship && !selected.sellingOnWebsite) {
          return false;
        }
      }
      return true;
    }
  }
};
